import { useMemo } from 'react';

import { FormBlocks, WorkflowStepFormFieldBlock } from '../../types';
import { filterBlocksOfType } from '../../utils/forms';

export const useFormBlocks = (
  blocks: FormBlocks,
): WorkflowStepFormFieldBlock[] => {
  const formFieldBlocks = useMemo(
    () => filterBlocksOfType(blocks, 'form-field'),
    [blocks],
  );

  return formFieldBlocks;
};
